import moment from 'moment';
import { DISPLAY_DATE_FORMAT, MILLION } from '@/consts';

export default {
  lateDays: (state) => {
    try {
      const transactionDate = moment(state.info.transactionDate, DISPLAY_DATE_FORMAT);
      const dueDate = moment(state.info.dueDate, DISPLAY_DATE_FORMAT);
      const days = transactionDate.diff(dueDate, 'days');
      return days >= 0 ? days : 0;
    } catch (error) {
      return 0;
    }
  },
  overdueFee: (state, getters) => {
    const interestAmountPerDay = (state.info.interestAmount * MILLION) / state.info.repayEvery;
    const overdueFee = interestAmountPerDay * getters.lateDays;
    return Math.round(overdueFee / 1000) / 1000;
  },
  totalAmount: (state, getters) => {
    let total = state.info.totalOutstanding * MILLION + getters.overdueFee * MILLION;

    if (!state.info.prepaid && state.info.promotionAmount) {
      total -= state.info.promotionAmount * MILLION;
    }

    return Math.round(total / 1000) / 1000;
  },
};
